export const enUSReports = {
  pageTitle: 'Reports',
  tabTrends: 'Trends',
  tabCategories: 'Categories',
  tabIncome: 'Income vs Expenses',
  allAccounts: 'All Accounts',
  noData: 'No data for this month',
  loading: 'Loading...',
  summaryTotalPaid: 'Total Paid',
  summaryTotalPending: 'Total Pending',
  summaryTotalIncome: 'Total Income',
  summaryTotalExpenses: 'Total Expenses',
  categoryTotal: 'Category Total',
  categoryDrillBack: 'Back',
  categoryNoSubcategories: 'No subcategories',
  categoryExpensesEmpty: 'No expenses in this category',
  expenseDate: 'Date',
  expenseDescription: 'Description',
  expenseAmount: 'Amount',
  expenseAccount: 'Account',
  expensePaid: 'Paid',
  expensePending: 'Pending',
  trendsHeading: 'Spending Trends',
  categoryHeading: 'Spending by Category',
  incomeHeading: 'Income vs Expenses',
  export: {
    button: 'Export',
    csvMonth: 'CSV (this month)',
    downloading: 'Exporting...',
    success: 'Export downloaded',
    error: 'Failed to export',
  },
} as const;
